import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
import Skeleton from 'react-loading-skeleton';
import GraficoCategoriaVenta from './GraficoCategoriaVenta';
import { useToast } from 'context/providers/ToastProvider';

const SalesStatistic = ({
    idUsuario,
    mes

}) => {

    const [stats, setStats] = useState([]);
    const [cargando, setCargando] = useState(true);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [courseEnrollments, setCourseEnrollments] = useState([])
    const ObtenerVentasPorCategoria = async (idUsuario, _date) => {
        setCargando(true);
        const response = await fetch("/api/home/ObtenerVentasPorCategoria/?idUsuario=" + idUsuario + "&date=" + _date, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            if (data['table1'][0].iResponseType == 1) {
                setStats(data['table2']);
                const resultFromSP = data['table3'];

                const formattedData = [
                    ["Month", "Buyback", "NewCustomerSales", "SaleByDistribution"],
                    ...resultFromSP.map(row => [
                        row.Month,
                        row.Buyback,
                        row.NewCustomerSales,
                        row.SaleByDistribution
                    ])
                ];

                setCourseEnrollments(formattedData);
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerVentasPorCategoria(idUsuario, mes);
    }, [idUsuario, mes])

    return (
        <Row className="align-items-center h-100">
            <Col sm={12} md={4} className="order-1 order-sm-0">
                {cargando ? <Skeleton className="w-75" /> :
                    stats.map((stat, index) => (
                        <div
                            key={stat.title.toLowerCase().split(' ').join('-')}
                            className={`${index !== 2 && 'pb-3 mb-3 border-bottom border-200'
                                }`}
                        >
                            <div className="position-relative ps-3">
                                <div
                                    className={`position-absolute h-100 start-0 rounded bg-${stat.color}`}
                                    style={{ width: '4px' }}
                                />
                                <h6 className="fs--2 text-600 mb-1">{stat.title}</h6>
                                <Flex alignItems="center">

                                    <CountUp
                                        start={0}
                                        end={stat.value}
                                        duration={2.75}
                                        className="text-700 fs-2 me-2"
                                        prefix="$"
                                        separator=","
                                    />
                                    <SoftBadge
                                        className="fs--2 fw-medium"
                                        bg={stat.colorPcent}
                                        pill
                                    >

                                        <FontAwesomeIcon icon={stat.icon} />{' '}
                                        {stat.percentage}
                                    </SoftBadge>

                                </Flex>
                            </div>
                        </div>
                    ))
                }

            </Col>
            <Col sm={12} md={8}>
                <GraficoCategoriaVenta data={courseEnrollments} />
            </Col>
        </Row>

    );
};

SalesStatistic.propTypes = {
    idUsuario: PropTypes.number,
    mes: PropTypes.instanceOf(Date)
};

export default SalesStatistic;
